export default "__VITE_ASSET__CjWtmbjg__"